import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a4786ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "properties-list" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "properties-hu" }, [
  /*#__PURE__*/_createElementVNode("span", null, "*h.u."),
  /*#__PURE__*/_createTextVNode(" or head unit describes the height of the head ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PropertiesList = _resolveComponent("PropertiesList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_PropertiesList)
    ]),
    _hoisted_3
  ]))
}